export default [
  [`Размер`, `36-39`, `40-42`]
];
